module.exports = __webpack_public_path__ + "static/media/testimonial.fb271bd7.jpg";